// Module
var code = `<installs-table
    prec="0"
    rows="rows"
    column-names="['started_count', 'finished_count', 'revenue_count', 'no_revenue_count']"
>
</installs-table>
`;
// Exports
module.exports = code;